import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=6c4382e2&scoped=true&"
import script from "./propaganda.vue?vue&type=script&lang=js&"
export * from "./propaganda.vue?vue&type=script&lang=js&"
import style0 from "./propaganda.vue?vue&type=style&index=0&id=6c4382e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4382e2",
  null
  
)

export default component.exports